module.exports = __webpack_public_path__ + "img/illustration-integre-01.153c5655.jpg";